import Vue from "vue"
import config from '../../config'

export default {
    getList(params = {}) {
        return Vue.http.get(config.apiBaseUrl + '/addons', { params }).then((response) => response.json());
    },

    getAddonsByCompany(companyId, params = {}) {
        return Vue.http.get(config.apiBaseUrl + '/addons/' + companyId, { params }).then((response) => response.json());
    }
}